import React from 'react';

import Modal from 'jbc-front/components/CommonModal';
import { TextField, SelectField } from 'src/jbc-front/components/Form';
import Button from 'jbc-front/components/Button';

import { maxLength30, isEmail, selectedInviteRole } from 'src/utils/CustomValidators';
import { INVITE_USER_ROLES } from 'src/constants/Options';
import { withTranslation } from 'react-i18next';

import styles from './InviteForm.scss';

class InviteForm extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }
  render() {
    const { handleSubmit, submitting, hideModal, pristine, t } = this.props;
    return (
      <div>
        <Modal.Header hideModal={hideModal}>{t('features.RoleUsers.components.InviteForm.Account_invitation')}</Modal.Header>
        <Modal.Body className={styles.modalBody} ref={this.ref}>
          <form onSubmit={handleSubmit}>
            <TextField name="email" label={t('features.Employees.components.BasicInfoSection.email')} required validate={isEmail} />
            <TextField name="name" label={t('features.RoleUsers.components.InviteForm.name')} required validate={maxLength30} />
            <SelectField
              required
              name="authority"
              label={t('features.RoleUsers.components.InviteForm.authority')}
              validate={selectedInviteRole}
              options={INVITE_USER_ROLES}
            />
            <dl className={styles.caution}>
              <dt className="u-mb5">{t('features.RoleUsers.components.InviteForm.warning')}</dt>
              <dd>{t('features.RoleUsers.components.InviteForm.Use_account_invitation_only_if_you_want_to_create_an_account_without_employee_information_such_as_account_for_certified_labor_consultant')}</dd>
              <dd>
                {t('features.RoleUsers.components.InviteForm.Also_please_note_that_the_account_and_employee_information_will_not_be_created_in_common_ID_and_cannot_be_linked_later')}
              </dd>
            </dl>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <Modal.Buttons>
            <Button onClick={hideModal}>{t('features.Clients.SocialSecurityContribution.Button.cancel')}</Button>
            <Button primary onClick={handleSubmit} disabled={submitting || pristine}>
              {t('features.RoleUsers.components.InviteForm.invite')}
            </Button>
          </Modal.Buttons>
        </Modal.Footer>
      </div>
    );
  }
}
export default withTranslation()(InviteForm);
